export const recentBookings = [
    {
      title: "Polka Bluish Purple Birthday Decor",
      image: "https://www.partyone.in/suploads/2024/Jun/30/38882/1719744216IMG_4592.webp",
      date: "April 2025",
      location: "Hyderabad",
      price: 4000,
    },
    {
        title: "Archery Game for Party",
        image: "https://www.partyone.in/suploads/2025/Apr/07/39195/1744000166image-5_Nero_AI_Image_Upscaler_Photo_display.webp",
        date: "May 2025",
        location: "Delhi",
        price: 3000,
      },
    {
      title: "Moonlit Moments Surprise Terrace Decor",
      image: "https://www.partyone.in/suploads/2024/Aug/22/38968/17243059994-Upload_display.webp",
      date: "May 2025",
      location: "Hyderabad",
      price: 8500,
    },
    {
      title: "Castle Theme Kids Bouncing Castle",
      image: "https://www.partyone.in/suploads/2025/Jan/08/39179/1736333696image29_display.webp",
      date: "March 2025",
      location: "Banglore",
      price: 6000,
    },
    {
      title: "Photography",
      image: "https://www.partyone.in/suploads/2016/Apr/22/12290/1461321349dslr-camera-photography-nikon-d3000-dslr-professional-camera-photography---pasig---cameras_display.webp",
      date: "May 2025",
      location: "Bangalore", 
      price: 5000,
    },
    {
      title: "Tattoo Artist",
      image: "https://www.partyone.in/suploads/2023/Jun/27/3857/1687849419tattoo_display.webp",
      date: "Feb 2025",
      location: "Pune",
      price: 7000,

    },
    {
      title: "Magician",
      image: "https://www.partyone.in/suploads/2024/Nov/26/3376/1732605173Magic-Showmp4_snapshot_0523-1_display.webp",
      date: "May 2025",
      location: "Bangalore",
      price: 9000,
    },
    {
      title: "Adult Birthday Party Champagne Decor",
      image: "https://www.partyone.in/suploads/2024/Aug/23/38995/172441278531-Upload.webp",
      date: "April 2025",
      location: "Hyderabad",
      price: 7000,
    },
    {
      title: "White & Gold Opulent Anniversary Decoration",
      image: "https://www.partyone.in/suploads/2024/Jun/22/38820/1719040504IMG_4464_display.webp",
      date: "April 2025",
      location: "Hyderabad",
      price: 3000,
    },
    {
      title: "Hire U Shaped Bride To Be Balloon Decor at Home ",
      image: "https://www.partyone.in/suploads/2025/Feb/05/39300/1738753910image-177_Nero-AI_Photo.webp",
      date: "May 2025",
      location: "Delhi",
      price: 7000,
    },
    {
      title: "Rainbow Wonderscape Theme Decoration",
      image: "https://www.partyone.in/suploads/2023/Jul/20/38118/1689852510rainbow_display.webp",
      date: "April 2025",
      location: "Hyderabad",
      price: 9000,
    },
    {
      title: "Jungle Safari Theme Decor for Birth Days",
      image: "https://www.partyone.in/get-review-image?file_name=BRYGJUSJMM/1747468105o8HUlIZN.jpg",
      date: "May 2025",
      location: "Hyderabad",
      price: 7000,
    }
  ];
  